/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_HeadingInputs */



/**
* | output |
* | --- |
* | "Marine inspection and consultancy, carried out worldwide." |
*
* @param {Services_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_heading = /** @type {((inputs?: Services_HeadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_HeadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("船舶检查与海事咨询，服务遍及全球。")
	return /** @type {LocalizedString} */ ("Marine inspection and consultancy, carried out worldwide.")
});